// extracted by mini-css-extract-plugin
export default {"form":"Prediction_form__BazwD","loading":"Prediction_loading__skaYV","control":"Prediction_control__cyYDC","actions":"Prediction_actions__PjX5h"};